import { Select } from '@forms/select';
import { Component } from 'react';
import { PaymentMethodOption } from './PaymentMethodOption';
import { PaymentMethodValue } from './PaymentMethodValue';
import styles from './SelectPaymentMethod.module.css';
import { TSelectedPayment } from '../EarlyRepayment.reducer';

export class SelectPaymentMethod extends Component<{
    addNewCard?: () => void;
    options: {
        type: string;
        value: string;
        cardLastDigits: string;
        issuer: string;
        brand: string;
        label: string;
    }[];
    name: string;
    onChange?: (selectedPayment: TSelectedPayment) => void;
    disabled?: boolean;
}> {
    render() {
        return (
            <Select
                className={styles.SelectPaymentMethod}
                {...this.props}
                selectOptions={{
                    className: styles.SelectPaymentMethodContainer,
                    classNameSelect: styles.SelectPaymentMethodDropDown,
                    valueComponent: PaymentMethodValue,
                    optionComponent: PaymentMethodOption,
                    ...this.props
                }}
            />
        );
    }
}
